import { Directive, HostListener } from "@angular/core";

import { SizeDetectorFacadeService } from "../services/size-detector-facade.service";

@Directive({ selector: "[resizeDetector]" })
export class ResizeDetectorDirective {
	constructor(private sizeDetectorFacade: SizeDetectorFacadeService) {}

	@HostListener("window:resize", ["$event"])
	onResize(event: Event): void {
		this.detectScreenSize((event.currentTarget as any).innerWidth);
	}

	private detectScreenSize(size: number): void {
		this.sizeDetectorFacade.setSize(size);
	}
}
